export enum BankAccountType {
  CURRENT_CHEQUE = 'CURRENT_CHEQUE',
  SAVINGS = 'SAVINGS',
  TRANSMISSION = 'TRANSMISSION',
}

export type BankAccount = {
  bankName?: string;
  branchName?: string;
  branchCode?: string;
  accountNumber?: string;
  accountType?: BankAccountType;
};

export type BankAccountExtraDetailsForCreditVetting = {
  debitOrderDate?: DebitOrderDate;
  bankAccountOpenSince: Date;
};

export enum RequiredBankDetailsType {
  NO_CREDIT_VETTING = 'NO_CREDIT VETTING',
  PERSONAL_ACCOUNT_CREDIT_VETTING = 'PERSONAL_ACCOUNT_CREDIT_CVETTING',
  BUSINESS_ACCOUNT_WITH_REG_NUMBER_CREDIT_VETTING = 'BUSINESS_ACCOUNT_WITH_REG_NUMBER_CREDIT_VETTING',
  BUSINESS_ACCOUNT_WITH_RSA_ID_NUMBER_CREDIT_VETTING = 'BUSINESS_ACCOUNT_WITH_RSA_ID_NUMBER_CREDIT_VETTING',
}

/*
 @property {string}  accountHolderFullName - per bank account details
  @property {string}  accountHolderIdNumber - not used - ignore
 */
export type BankDetailsNoCreditVetting = {
  type: RequiredBankDetailsType.NO_CREDIT_VETTING;
  accountHolderFullName: string;
} & BankAccount;

/*
 @property {string}  accountHolderFullName <first names> <surname>
 @property {string}  accountHolderIdNumber <RSA ID number>
 */
export type PersonalBankDetails = {
  type: RequiredBankDetailsType.PERSONAL_ACCOUNT_CREDIT_VETTING;
  accountHolderFullName: string;
  accountHolderIdNumber: string;
} & BankAccountExtraDetailsForCreditVetting &
  BankAccount;

/*
 @property {string}  accountHolderFullName - name of business that registered bank account
 @property {string}  accountHolderIdNumber - registration number of business
 */
export type RegisteredBusinessBankDetails = {
  type: RequiredBankDetailsType.BUSINESS_ACCOUNT_WITH_REG_NUMBER_CREDIT_VETTING;
  accountHolderFullName: string;
  accountHolderIdNumber: string;
} & BankAccountExtraDetailsForCreditVetting &
  BankAccount;

/*
 @property {string}  accountHolderFullName - name of business that registered bank account
 @property {string}  accountHolderIdNumber - RSA ID number of merchant who opened bank account
 */
export type UnregisteredBusinessBankDetails = {
  type: RequiredBankDetailsType.BUSINESS_ACCOUNT_WITH_RSA_ID_NUMBER_CREDIT_VETTING;
  accountHolderFullName: string;
  accountHolderIdNumber: string;
  identificationType: string;
} & BankAccountExtraDetailsForCreditVetting &
  BankAccount;

export type BankDetails =
  | BankDetailsNoCreditVetting
  | PersonalBankDetails
  | RegisteredBusinessBankDetails
  | UnregisteredBusinessBankDetails;

// Only required for credit vetting rental products
export enum DebitOrderDate {
  FIRST_DAY_OF_MONTH = 'First day of month',
  LAST_DAY_OF_MONTH = 'Last day of the month',
  DAY_7 = '7',
  DAY_8 = '8',
  DAY_9 = '9',
  DAY_10 = '10',
  DAY_11 = '11',
  DAY_12 = '12',
  DAY_13 = '13',
  DAY_14 = '14',
  DAY_15 = '15',
  DAY_16 = '16',
  DAY_17 = '17',
  DAY_18 = '18',
  DAY_19 = '19',
  DAY_20 = '20',
  DAY_21 = '21',
  DAY_22 = '22',
  DAY_23 = '23',
  DAY_24 = '24',
  DAY_25 = '25',
  DAY_26 = '26',
  DAY_27 = '27',
  DAY_28 = '28',
  DAY_29 = '29',
  DAY_30 = '30',
}
